import { useQuery } from "react-query";
import { apiPost } from "../../api/client";
import { useWorkspace } from "../../context/WorkspaceContext";
import { useUserSession } from "../../context/UserContext";
import { useCache } from "../../context/CacheContext";

export type OrderCompleteness = {
  missing: string[];
  needsAttention: boolean;
  editable: boolean;
};
export function useDriverOrderCompleteness(orderIds: string[]) {
  const { activeWorkspace } = useWorkspace();
  const { userSession } = useUserSession();
  const { cacheKey } = useCache();
  const workspace = activeWorkspace?.workspaceId;
  const token = userSession?.token?.accessToken;
  const ids = Array.from(
    new Set(orderIds.filter((id) => id.startsWith("drv_"))),
  ).sort();
  return useQuery<Record<string, OrderCompleteness>>(
    ["driverOrderCompleteness", workspace, ids, cacheKey],
    async () => {
      const result: Record<string, OrderCompleteness> = {};
      for (let start = 0; start < ids.length; start += 200) {
        const response = await apiPost(
          token!,
          "/api/drivers/order-completeness",
          { orderIds: ids.slice(start, start + 200) },
          workspace!,
        );
        Object.assign(result, response.data);
      }
      return result;
    },
    {
      enabled: Boolean(workspace && token && ids.length),
      refetchInterval: 30000,
      staleTime: 5000,
    },
  );
}
